export const ubicaciones = [
  {Id:'GD', Nombre: "A. METRO GUADALAJARA"},
  {Id:'MO', Nombre: "A. METRO MONTERREY"},
  {Id:'MX', Nombre: "A. METRO CD. MEXICO"},
  {Id:'NI', Nombre: "OTRAS PLAZAS"},
]
